export const environment = {
  production: true,
  apiUrl: '/api',
  baseUrl: '',
  hubUrl: '/chat-hub'
};
